import { MedicineSimple } from '@dreryk/drerykweb-medicine-api';
import { PrescriptionStatusForContinuouslyUsedMedicines } from '@dreryk/egabinet-visit-frontend-api';

import { MedicineDetailsModalOpenAction, MedicineName } from '~libs.desktop.shared.medicine';

import { visitPrescriptionTranslationKeys } from '../../../../../translations';
import { ContinuouslyUsedMedicinesPrescriptionStatus } from '../../VisitContinuouslyUsedMedicineTable';

type VisitContinuouslyUsedMedicineNameProps = {
   readonly medicine: MedicineSimple;
   readonly requestHandler: VoidFunction | null;
   readonly prescriptionStatus: PrescriptionStatusForContinuouslyUsedMedicines;
};

const resolveConfirmationButtonLabel = (
   prescriptionStatus: PrescriptionStatusForContinuouslyUsedMedicines
): string | undefined => {
   switch (prescriptionStatus) {
      case ContinuouslyUsedMedicinesPrescriptionStatus.DRAFT:
         return visitPrescriptionTranslationKeys.removeFromPrescription;
      case ContinuouslyUsedMedicinesPrescriptionStatus.NO_PRESCRIPTION:
         return visitPrescriptionTranslationKeys.addToPrescription;
      case ContinuouslyUsedMedicinesPrescriptionStatus.ACCEPTED:
      default:
         return undefined;
   }
};

const VisitContinuouslyUsedMedicineName = (props: VisitContinuouslyUsedMedicineNameProps): JSX.Element => {
   return (
      <MedicineDetailsModalOpenAction
         confirmationButtonLabel={resolveConfirmationButtonLabel(props.prescriptionStatus)}
         medicine={props.medicine}
         onConfirm={props.requestHandler}
         render={(openModal) => (
            <MedicineName
               name={props.medicine.fullName}
               onClick={openModal}
               atc={props.medicine.atc}
               valid={props.medicine.valid}
            />
         )}
      />
   );
};

export { VisitContinuouslyUsedMedicineName };
